module.exports = __webpack_public_path__ + "static/media/Notifica_gralpng.dc13587e.png";